import { Box, Stack, Typography, Avatar, Rating } from '@mui/material';
import defaultUserThumbnail from '../../assets/default_user_thumbnail.svg';
import theme from '../../theme';
import GradeIcon from './GradeIcon';

const ReviewerProfile = ({ imageUrl, name, rating, imageHref, nameHref, grade, onLinkClick }) => {
  const avatarEl = (
    <Avatar
      src={imageUrl || defaultUserThumbnail}
      sx={{
        width: 32,
        height: 32,
        cursor: imageHref ? 'pointer' : 'default',
        border: `1px solid ${theme.palette.grey.line}`,
      }}
    />
  );

  const nameEl = (
    <Stack
      direction="row"
      alignItems="center"
      spacing={0.5}
      sx={{ minWidth: 0, maxWidth: '100%', width: 'fit-content' }}
    >
      <Typography
        fontSize={{ xs: 12, md: 13 }}
        fontWeight={'bold'}
        color={theme.palette.black[6]}
        sx={{
          flex: '0 1 auto',
          minWidth: 0,
          maxWidth: '100%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {name}
      </Typography>
      <GradeIcon grade={grade} />
    </Stack>
  );

  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ minWidth: 0, maxWidth: '100%' }}>
      {imageHref ? (
        <a
          href={imageHref}
          target="_blank"
          rel="noopener noreferrer"
          onClick={onLinkClick}
          style={{ flexShrink: 0 }}
        >
          {avatarEl}
        </a>
      ) : (
        avatarEl
      )}
      <Stack
        direction="column"
        spacing={0.5}
        sx={{ flex: '1 1 auto', minWidth: 0, maxWidth: '100%' }}
      >
        {nameHref ? (
          <a
            href={nameHref}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-flex',
              minWidth: 0,
              maxWidth: '100%',
              textDecoration: 'none',
            }}
            onClick={onLinkClick}
          >
            {nameEl}
          </a>
        ) : (
          nameEl
        )}
        {rating != null && (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Rating
              readOnly
              value={rating}
              precision={0.5}
              sx={{
                fontSize: 12,
                color: theme.palette.secondary.main,
              }}
            />
            <Typography fontSize={12} fontWeight={600} sx={{ ml: 0.5 }}>
              {(rating || 0).toFixed(1)}
            </Typography>
          </Box>
        )}
      </Stack>
    </Stack>
  );
};

export default ReviewerProfile;
